import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	private themeSubject = new BehaviorSubject<'light' | 'dark'>('light');
	theme$ = this.themeSubject.asObservable();

	constructor() {
		const saved = localStorage.getItem('theme');
		if (saved === 'light' || saved === 'dark') {
			this.setTheme(saved);
		}
	}

	setTheme(theme: string) {
		const validTheme = theme.includes('light') ? 'light' : theme.includes('dark') ? 'dark' : null;

		if (!validTheme) {
			return;
		}

		const themeLink = document.getElementById('theme-css') as HTMLLinkElement;
		if (themeLink) {
			themeLink.href = `/assets/themes/aura-${validTheme}-indigo/theme.css`;
		}

		document.documentElement.setAttribute('data-theme', validTheme);
		localStorage.setItem('theme', validTheme);

		this.themeSubject.next(validTheme as 'light' | 'dark');
	}

	getTheme(): 'light' | 'dark' {
		return this.themeSubject.value;
	}
}
